var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner"},_vm._l((12),function(item,i){return _c('div',{key:i,class:("bar" + (i+1)),style:(_vm.setBackColor)})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }